<template>
  <v-container fill-height v-if="!loadingPersonal">
    <v-row align="center" justify="center" v-if="personalCompleto">
      <v-col cols="9" align="center" justify="center">
        <div class="font-weight-bold">Información del personal</div>

        <v-container>
          <v-row align="center">
            <v-col cols="12" align="center">
              <v-avatar rounded color="secondary" size="80" v-if="!personalCompleto.foto">
                <v-icon x-large color="primary">mdi-account</v-icon>
              </v-avatar>
              <v-img
                v-else
                :src="personalCompleto.foto"
                max-height="80"
                max-width="80"
                @error="personalCompleto.foto = null"
              ></v-img>
            </v-col>
            <v-col cols="12" align="center" class="pb-0">
              <div class="text-subtitle-1 text--primary">
                {{ getFullName(personalCompleto) }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <div class="text-subtitle-2 secondary--text">Datos generales</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">CUIP</div>
              <div class="text-body-1 text--primary">{{ personalCompleto.CUIP || 'Sin datos' }}</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">CURP</div>
              <div class="text-body-1 text--primary">{{ personalCompleto.curp || 'Sin datos' }}</div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <div class="text-subtitle-2 secondary--text">Contacto</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">Teléfono celular</div>
              <div class="text-body-1 text--primary">
                {{ personalCompleto.Contacto?.telefonoCelular || 'Sin datos' }}
              </div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">Teléfono fijo</div>
              <div class="text-body-1 text--primary">
                {{ personalCompleto.Contacto?.telefonoFijo || 'Sin datos' }}
              </div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">E-mail</div>
              <div class="text-body-1 text--primary">
                {{ personalCompleto.Contacto?.correoElectronico || 'Sin datos' }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <div class="text-subtitle-2 secondary--text pb-2">Registro de asistencia</div>
            </v-col>
            <v-col cols="12" align="left">
              <v-select
                v-model="asistencia"
                :items="tiposAsistencia"
                label="Selecciona asistencia"
                outlined
                dense
                color="primary"
                class="mt-2"
                item-text="title"
                item-value="id"
                hide-details
                :loading="loadingTipos"
              ></v-select>
            </v-col>
            <v-col cols="12" align="center">
              <TextButton
                rounded
                color="secondary"
                @click="guardarAsistencia"
                :loading="loading"
                :disabled="!asistencia || loading"
              >
                Guardar cambios
              </TextButton>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" v-else>
      <v-col cols="12" align="center">
        <div class="text-subtitle-1 text--primary">No se pudo cargar la información del personal</div>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="secondary"></v-progress-circular>
        <div class="text-subtitle-1 text--primary mt-4">Cargando información...</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TextButton from '@src/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  props: {
    selectedPersonal: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      asistencia: null,
      loading: false,
      loadingTipos: false,
      loadingPersonal: false,
      personalCompleto: null,
      API_DATE_FORMAT: 'YYYY-MM-DD',
    }
  },

  computed: {
    ...mapGetters('asistencia', {
      tiposAsistencia: 'getTiposAsistencia',
    }),
  },

  async mounted() {
    await Promise.all([this.fetchTiposAsistencia(), this.fetchPersonalCompleto()])
  },

  methods: {
    ...mapActions('asistencia', ['fetchTipoAsistencia', 'saveAsistencia', 'verificarAsistenciaHoy']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async fetchTiposAsistencia() {
      try {
        this.loadingTipos = true
        await this.fetchTipoAsistencia()
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al cargar los tipos de asistencia.')
      } finally {
        this.loadingTipos = false
      }
    },

    async fetchPersonalCompleto() {
      if (!this.selectedPersonal) return

      try {
        this.loadingPersonal = true
        const idPersonal = this.selectedPersonal.idPersonal || this.selectedPersonal.id_personal

        console.log('🔍 Cargando datos completos del personal:', idPersonal)

        // Llamar al action que obtiene el personal completo
        await this.fetchPersonalById(idPersonal)

        this.personalCompleto = this.$store.getters['personal/getPersonalSingle']
      } catch (error) {
        console.error('❌ Error al cargar personal completo:', error)
        this.SET_SNACKBAR_MESSAGE('Error al cargar la información del personal.')
        this.personalCompleto = null
      } finally {
        this.loadingPersonal = false
      }
    },

    getFullName(person) {
      if (!person) return 'Sin nombre'

      const nombre = person.nombre || ''
      const segundoNombre = person.segundoNombre || ''
      const apaterno = person.apaterno || ''
      const amaterno = person.amaterno || ''

      return `${apaterno} ${amaterno} ${nombre} ${segundoNombre}`.trim()
    },

    async guardarAsistencia() {
      if (!this.asistencia) {
        this.SET_SNACKBAR_MESSAGE('Por favor selecciona un tipo de asistencia.')
        return
      }

      try {
        this.loading = true

        const personalId = this.selectedPersonal.idPersonal || this.selectedPersonal.id_personal

        const tieneAsistenciaHoy = await this.verificarAsistenciaHoy(personalId)

        if (tieneAsistenciaHoy) {
          this.SET_SNACKBAR_MESSAGE('Ya se registró asistencia para este personal el día de hoy.')
          this.loading = false
          return
        }

        const payload = {
          fk_idPersonal: personalId,
          fk_idTipoAsistencia: this.asistencia,
          fecha: moment().format(this.API_DATE_FORMAT),
        }

        await this.saveAsistencia({
          idPersonal: payload.fk_idPersonal,
          asistencia: payload,
        })

        this.$emit('close')
        this.asistencia = null
      } catch (error) {
        console.error('Error al guardar asistencia:', error)
        this.SET_SNACKBAR_MESSAGE('Error al guardar la asistencia.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}
</style>
